






import { Component } from 'vue-property-decorator';
import SmsPointSummary from './SmsPointSummary.vue';

@Component
export default class MessageSendCount extends SmsPointSummary {
  get smsCount() {
    const point = Number(this.totalPoint) || 0;

    // NOTE: SMS: 건당 1 포인트 소모
    return Math.max(0, Math.floor(point)).toLocaleString();
  }

  get alimtalkCount() {
    const point = Number(this.totalPoint) || 0;

    // NOTE: 알림톡: 건당 0.6 포인트 소모
    return Math.max(0, Math.floor(point / 0.6)).toLocaleString();
  }
}
